// TODO: get Entry Year options from backend
export const convertEntryYearMap: Record<string, string> = {
  '2023-03': 'May 2024(Summer term)',
  '2024-01': 'Sept 2024(Sem 1)',
  '2024-02': 'Jan 2025(Sem 2)',
  '2024-03': 'May 2025(Summer term)',
  '2025-01': 'Sept 2025(Sem 1)',
  '2025-02': 'Jan 2026',
  '2025-03': 'May 2026',
  '2026-01': 'Sept 2026',
  '2026-02': 'Jan 2027',
  '2026-03': 'May 2027',
};

export const enum PAYMENT_TYPE {
  APPLICATION_FEE = 'APPLICATION_FEE',
  REGISTRATION_FEE = 'REGISTRATION_FEE',
  TUITION_FEE = 'TUITION_FEE',
}
